var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#212121"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
    transform: "rotate(90 12 12) translate(-.295)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0)",
    d: "M0 0h24v24H0z",
    transform: "rotate(90 12 12)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMjEyMTIxIiA+CiAgICA8Zz4KICAgICAgICA8cGF0aCBkPSJNMTAgNkw4LjU5IDcuNDEgMTMuMTcgMTJsLTQuNTggNC41OUwxMCAxOGw2LTZ6IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAxMiAxMikgdHJhbnNsYXRlKC0uMjk1KSIvPgogICAgICAgIDxwYXRoIGZpbGw9InJnYmEoMCwwLDAsMCkiIGQ9Ik0wIDBoMjR2MjRIMHoiIHRyYW5zZm9ybT0icm90YXRlKDkwIDEyIDEyKSIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgArrowDown as ReactComponent };